module.exports = __webpack_public_path__ + "img/bg_azul_desktop.83c992ed.png";